// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomerPortalThemeCard_boxLabel__HaGQf {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/settings-page/CustomerPortalThemeCard.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[".boxLabel {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxLabel": `CustomerPortalThemeCard_boxLabel__HaGQf`
};
export default ___CSS_LOADER_EXPORT___;
